/** Public ElevenLabs agent id — not a secret; server may override via ELEVENLABS_AGENT_ID. */
export const ELEVENLABS_AGENT_ID = "agent_4401m16vz77vefz9gbptg13mjw17";

export const ELEVENLABS_TOKEN_PATH = "/api/elevenlabs/conversation-token";
